import { Routes } from '@angular/router';
import { Email } from '@/features/configuracoes/geral/email/email';
import { Servicos } from '@/features/configuracoes/geral/servicos/servicos';
import { Modulos } from '@/features/configuracoes/geral/modulos/modulos';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';

const rootPath = CONFIGURACOES_ROUTES.GERAIS.ROOT;

export const configuracoesGeraisRoutes: Routes = [
    {
        path: rootPath,
        data: { breadcrumb: 'Gerais' },
        children: [
            { path: '', redirectTo: CONFIGURACOES_ROUTES.GERAIS.EMAIL, pathMatch: 'full' },
            { path: CONFIGURACOES_ROUTES.GERAIS.EMAIL, component: Email, data: { breadcrumb: 'E-Mail' } },
            { path: CONFIGURACOES_ROUTES.GERAIS.SERVICOS, component: Servicos, data: { breadcrumb: 'Serviços' } },
            { path: CONFIGURACOES_ROUTES.GERAIS.MODULOS, component: Modulos, data: { breadcrumb: 'Módulos' } }
        ]
    }
];

export default configuracoesGeraisRoutes;
